import React from 'react'

import { NumberBox, NumbersWrapper, NumberText } from './Countdown.style'
import { formatTime } from './Countdown.utils'
import { useLoopingCountdown } from './useLoopingCountdown'

const Countdown = () => {
  const remainingMs = useLoopingCountdown()
  const { hours, minutes, seconds } = formatTime(remainingMs)

  return (
    <NumbersWrapper>
      <NumberBox>
        <NumberText>{hours}</NumberText>
      </NumberBox>
      <NumberText>:</NumberText>
      <NumberBox>
        <NumberText>{minutes}</NumberText>
      </NumberBox>
      <NumberText>:</NumberText>
      <NumberBox>
        <NumberText>{seconds}</NumberText>
      </NumberBox>
    </NumbersWrapper>
  )
}

export default Countdown
